import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import FootBar from './FootBar';
import DropDownEmployee from './DropDownEmployee';
import { updateEmployee, refreshReferential } from '../../app/updateApp';
import SecurityReport from '../../securityReports';
import noSupply from '../../../assets/no-supply.png';

const EmployeeSecurity = () => {
    const { t } = useTranslation();
    useEffect(function () {
        refreshReferential().then(() => updateEmployee(employeeState.selectedEmployee));
    }, []);

    const employeeState = useSelector(state => state.employees);
    const securityReports = useSelector(state => state.securityReports.all.filter(sr => sr.employee_id === employeeState.selectedEmployee));

    const showNoData = securityReports.length === 0;

    let currentEmploye = employeeState.team.find(empl =>
        empl.id === employeeState.selectedEmployee
    );
    if (!currentEmploye) {
        currentEmploye = employeeState.all.find(empl =>
            empl.id === employeeState.selectedEmployee
        );
    }

    return <div className="module-page">
        <DropDownEmployee />
        <div style={{marginTop:'32px'}}>
            {showNoData ?
                <div className="no-supply">
                    <img src={noSupply} />
                </div>
                : <SecurityReport reports={securityReports}/>
            }
        </div>
        <FootBar />
    </div>;
};

export default EmployeeSecurity;